// extracted by mini-css-extract-plugin
export default {"ChartContainer":"riskReturnHitRatio_ChartContainer__mbOaE","Chart":"riskReturnHitRatio_Chart__mkl2t"};